"use client";

import type { SelectedAccommodationReservation } from "../../reservation-form/reservation-calendar/reservation-calendar";
import type { RoomTypeReserveContextValue } from "../_context/room-type-reserve-context";

import {
  RoomTypeReservationCalendar,
  type RoomTypeReservationConfirmOptions,
} from "./room-type-reservation-calendar";

export function RoomTypeReserveInlineContent({
  roomTypeId,
  ctx,
  closeAll,
}: {
  roomTypeId: string;
  ctx: RoomTypeReserveContextValue;
  closeAll: () => void;
}) {
  const handleConfirm = (
    selection: SelectedAccommodationReservation,
    options: RoomTypeReservationConfirmOptions,
  ) => {
    // setStayRange で一覧 URL を更新すると router.push と競合して遷移しないため、日程は遷移先 URL で運ぶ。
    ctx.onDraftSelected({ ...selection, roomTypeId }, options);
    // /ticket-issue へのフルページ遷移中に drawer を閉じると、拠点詳細の URL 同期が遷移と競合しうるため閉じない。
    if (options.stayTicketTemplateLookupKey === null) closeAll();
  };

  if (ctx.stayTicketMasterReference !== null) {
    return (
      <RoomTypeReservationCalendar
        mode="stayTicketMaster"
        roomTypeId={roomTypeId}
        stayTicketMasterReference={ctx.stayTicketMasterReference}
        noCancelOptionConfig={ctx.noCancelOptionConfig}
        evChargerAvailable={ctx.evChargerAvailable}
        initialFirstNight={ctx.firstNight}
        initialLastNight={ctx.lastNight}
        minNightFloor={ctx.minNight}
        maxStayNights={ctx.maxStayNights}
        unavailablePeriods={ctx.unavailablePeriods}
        onConfirm={handleConfirm}
      />
    );
  }

  return (
    <RoomTypeReservationCalendar
      mode="provider"
      roomTypeId={roomTypeId}
      provider={ctx.provider}
      stayTicketMasterId={ctx.stayTicketMasterId}
      evChargerAvailable={ctx.evChargerAvailable}
      initialFirstNight={ctx.firstNight}
      initialLastNight={ctx.lastNight}
      minNightFloor={ctx.minNight}
      maxStayNights={ctx.maxStayNights}
      unavailablePeriods={ctx.unavailablePeriods}
      onConfirm={handleConfirm}
    />
  );
}
